import { Component } from '@angular/core';
import { EnvironmentService } from './services/environment.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor(private environmentService: EnvironmentService) {}

    title = 'app';

    ngOnInit() {
        this.environmentService.initialize();
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts